// FAMILY-EXT: хук, обновляющий "сейчас" каждую минуту, чтобы счётчики
// длительности (баннер 'Жду', чип на карточке, журнал) сами тикали
// без обновления страницы.
import { useEffect, useState } from 'react';

export function useTickingNow(intervalMs = 30000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
